module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.9adcd6ea.eot";